<template>
  <div class="container-fluid dashboard">
    <div
      class="container-title flex-column flex-sm-row justify-content-start justify-content-sm-between align-items-sm-center"
    >
      <h3 class="font-montserrat">{{ $t("page.main.dashboard") }}</h3>
      <div class="row g-0 mt-3 mt-sm-0">
        <input
          type="month"
          class="form-control-md"
          v-model="searchData.regdate"
        />
      </div>
    </div>
    <div class="contents">
      <h4 class="subtitle">{{ $t("page.main.notice") }}</h4>
      <table class="table board">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell w-1">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto w-1">
              {{ $t("title.main.category") }}
            </th>
            <th class="col-auto">{{ $t("title.main.title") }}</th>
            <th class="col-auto d-none d-md-table-cell w-1">
              {{ $t("title.main.date") }}
            </th>
            <th class="th-arrow">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, index) in noticetop5">
            <tr :key="index">
              <td class="col-auto d-none d-lg-table-cell w-1">{{ item.no }}</td>
              <td class="col-auto w-1">
                <span class="icon badge bg-purple" v-if="item.type === '1'">
                  {{ $t("title.setting.notice") }}
                </span>
                <span class="icon badge bg-blue" v-if="item.type === '2'">
                  {{ $t("title.setting.patch") }}
                </span>
              </td>
              <td class="col-auto text-start">
                <router-link
                  :to="{
                    name: 'NoticeView',
                    params: { noticeno: item.noticeno },
                  }"
                  class="more"
                  >{{ item.title }}</router-link
                >
              </td>
              <td class="col-auto d-none d-md-table-cell w-1 text-date">
                {{ item.timezone_date | dateformat }}
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-lg-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="5">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">{{ $t("title.main.number") }}</div>
                    <div class="col-8">{{ item.no }}</div>
                  </div>
                  <!--                   <div class="row">
                    <div class="col-4">{{ $t("title.main.category") }}</div>
                    <div class="col-8 text-date">
                      {{
                        item.type === "1"
                          ? $t("title.setting.notice")
                          : $t("title.setting.patch")
                      }}
                    </div>
                  </div> -->
                  <div class="row d-md-none">
                    <div class="col-4">{{ $t("title.common.date") }}</div>
                    <div class="col-8 text-date">
                      {{ item.timezone_date | dateformat }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>

      <h4 class="subtitle mt-5">{{ $t("page.main.game_summary") }}</h4>
      <div
        class="row g-0 row-cols-1 row-cols-sm-2 table-type header-col p-keep"
      >
        <div class="col-sm">
          <p>
            {{ $t("title.main.rounds") }}
            <small class="fw-normal text-dark">{{
              $t("title.main.todaytotal")
            }}</small>
          </p>
        </div>
        <div class="col-sm">
          {{ roundsummary.roundtodaycnt | comma }} /
          {{ roundsummary.roundtotalcnt | comma }}
        </div>
        <div class="col-sm">
          <p>
            {{ $t("title.main.members") }}
            <small class="fw-normal text-dark">{{
              $t("title.main.todaytotal")
            }}</small>
          </p>
        </div>
        <div class="col-sm">
          {{ roundsummary.playertodaycnt | comma }} /
          {{ roundsummary.playertotalcnt | comma }}
        </div>
      </div>

      <h4 class="subtitle mt-5">{{ $t("page.main.tournament_summary") }}</h4>
      <div
        class="row g-0 row-cols-1 row-cols-sm-2 table-type header-col p-keep"
      >
        <div class="col-sm">
          <p>
            {{ $t("title.setting.tournament") }}
            <small class="fw-normal text-dark">{{
              $t("title.main.startingtotal")
            }}</small>
          </p>
        </div>
        <div class="col-sm">
          {{ torunamentsummary.tournamenttodaycnt | comma }} /
          {{ torunamentsummary.tournamenttotalcnt | comma }}
        </div>
        <div class="col-sm">
          <p>
            {{ $t("title.main.rounds") }}
            <small class="fw-normal text-dark">{{
              $t("title.main.todaytotal")
            }}</small>
          </p>
        </div>
        <div class="col-sm">
          {{ torunamentsummary.roundtodaycnt | comma }} /
          {{ torunamentsummary.roundtotalcnt | comma }}
        </div>
        <div class="col-sm">
          <p>
            {{ $t("title.main.members") }}
            <small class="fw-normal text-dark">{{
              $t("title.main.todaytotal")
            }}</small>
          </p>
        </div>
        <div class="col-sm">
          {{ torunamentsummary.playertodaycnt | comma }} /
          {{ torunamentsummary.playertotalcnt | comma }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ax from "@/api/main";
import "@/filter/common";

export default {
  name: "Main",
  components: {},
  data() {
    return {
      searchData: {
        regdate:
          this.$route.query.regdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].regdate) ||
          this.$dayjs().format("YYYY-MM"),
      },
      noticetop5: [],
      data_yn: true,
      roundsummary: [
        {
          roundtodaycnt: "0",
          roundtotalcnt: "0",
          playertodaycnt: "0",
          playertotalcnt: "0",
        },
      ],
      torunamentsummary: [
        {
          tournamenttodaycnt: "0",
          tournamenttotalcnt: "0",
          roundtodaycnt: "0",
          roundtotalcnt: "0",
          playertodaycnt: "0",
          playertotalcnt: "0",
        },
      ],
      view_hide: null,
    };
  },
  mounted() {
    this.getMain();
  },
  methods: {
    getMain() {
      ax.getMain(this.searchData, (flag, data) => {
        if (flag) {
          this.noticetop5 = data.noticetop5;
          if (data.noticetop5cnt <= 0) {
            this.data_yn = false;
            return false;
          } else {
            this.data_yn = true;
          }
          this.roundsummary = data.roundsummary;
          this.torunamentsummary = data.torunamentsummary;
        } else {
          alert(data.message);
          // this.$notify({
          //   group: "alert",
          //   type: "warn",
          //   title: "Notice",
          //   text: data.message,
          // });
        }
      });
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  watch: {
    "searchData.regdate": function () {
      this.getMain();
    },
  },
};
</script>
